import './Music.sass'

function Music() {
  const services = [
    {title: "Bandcamp", link: "https://bealtaineceol.bandcamp.com/"},
    {title: "Spotify", link: "https://open.spotify.com/artist/3jmqtucs3MmWrxm4esn9tq"},
    {title: "iTunes", link: "https://music.apple.com/us/artist/bealtaine/1634829850"},
    {title: "Amazon Music", link: "https://music.amazon.com/artists/B0B725N1NR/bealtaine"},
    {title: "YouTube Music", link: "https://music.youtube.com/channel/UCj44UWc65NL_F_vqaoIe32A"},
    {title: "Pandora", link: "https://www.pandora.com/artist/bealtaine/ARq9P5Xmgj4w4kc"}
  ]

  return (
    <div className="MusicPane">
      <div className="TopRow">
        <iframe style={{borderRadius: '12px'}}
          width={window.innerWidth >= 1200 ? '600' : window.innerWidth - 56}
          height={window.innerWidth >= 1200 ? '337' : (window.innerWidth - 56) * 0.561}
          src="https://www.youtube.com/embed/z-qFPNomrZw?si=E0NBdtzM109Mvo3O"
          title="YouTube video player" frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
        </iframe>
        <div className="Services">
          <h3>Find us on your favorite streaming service!</h3>
          {services.map(service => (
            <a key={service.title} href={service.link} target="_blank" rel="noreferrer">{service.title}</a>
          ))}
        </div>
      </div>

      <iframe style={{borderRadius: '12px'}} title="Factories & Mills, Shipyards & Mines"
        src="https://open.spotify.com/embed/album/5VXEhFlkzDdIjTgUI1bzVv?utm_source=generator"
        width="100%" height="352" frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy">
      </iframe>
      <div className="FoundersRoom">
        <iframe style={{borderRadius: '12px'}} title="The Founders' Room"
          src="https://open.spotify.com/embed/album/0QEiMSn1szIn8a5d6vwqer?utm_source=generator"
          width="100%" height="352" frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy">
        </iframe>
        <iframe style={{borderRadius: '12px'}} title="The Founders' Room, Vol. 2"
          src="https://open.spotify.com/embed/album/2DoX288xHNJXd03ImAUmjP?utm_source=generator"
          width="100%" height="352" frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy">
        </iframe>
      </div>
    </div>
  )
}

export default Music;
